import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription, filter } from 'rxjs';
import { DataGridColumn, DataGridResponse, DataGridExportOptions, SummaryCard, DashboardSummary } from 'src/app/utils/interfaces';
import { UserService } from 'src/app/services/user.service';
import { UserInfo, LogStatus, LogError } from '@memberjunction/core';
// import { Utils } from 'src/app/utils/utils';
// import { ChapterDuesSummaryEntity, DuesRecordsMetricsEntity } from 'mj_generatedentities';
import { AcsDataGridComponent } from '../shared/acs-data-grid/acs-data-grid';
import { DropdownOption } from '../shared/acs-button/acs-button';
import { DuesGridColumns, GridExportOptions } from 'src/app/utils/grid-constants';
import { EntityNames } from 'src/app/utils/constants';
// import { DataFetchService } from 'src/app/services/data-fetch.service';
import { UserAuthService } from 'src/app/services/user-auth.service';
import { ActiveUserService } from 'src/app/services/active-user.service';

@Component({
  selector: 'acs-chapter-dues',
  templateUrl: './chapter-dues.html',
  styleUrls: ['../../../styles/_page-layout.scss', './chapter-dues-specific.scss']
})
export class ChapterDuesComponent implements OnInit, OnDestroy {
  @ViewChild('duesGrid') duesGrid!: AcsDataGridComponent;
  private subscription = new Subscription();
  readonly entityName = EntityNames.ChapterDuesSummaries;

  isLoading = false; // Server-side grid handles its own loading
  error: string | null = null;
  
  // Summary data
  // summary!: DuesRecordsMetricsEntity;

  // summaryCards: SummaryCard[] = [];
  currentUser!: UserInfo;
  
  // Grid Configuration
  gridColumns: DataGridColumn[] = [];

  // Export dropdown options
  exportOptions: DropdownOption[] = GridExportOptions;

  constructor(
    private userService: UserService,
    private activeUserService: ActiveUserService,
    // private dataFetchService: DataFetchService,
    private userAuthService: UserAuthService
  ) {}
  
  ngOnInit(): void {
    this.subscription.add(
      this.userService.getUserComplete$.pipe(filter(complete => complete)).subscribe(() => {
        this.initializeComponent();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  initializeComponent(): void {
    this.currentUser = this.activeUserService.getActiveUser()!;
    this.gridColumns = DuesGridColumns;
    // this.loadSummaryData();
  }


  onServerDataError(error: any): void {
    LogError('Error loading chapter dues data:', undefined, error);
    this.error = 'Failed to load dues data. Please try again.';
  }
  
  onExportOptionSelected(option: DropdownOption): void {
    const format = option.value as 'csv' | 'excel' | 'pdf';
    
    // Use the duesGrid to perform the export
    if (this.duesGrid) {
      this.duesGrid.onExport(format);
      LogStatus(`Exporting all chapter dues as ${format.toUpperCase()}`);
    } else {
      alert('Grid not available for export. Please try again.');
    }
  }

  /*
  private async loadSummaryData(): Promise<void> {
    // Initialize summary data - will be updated when data loads
    const result = await this.dataFetchService.fetchWithParams<DuesRecordsMetricsEntity>({
          EntityName: EntityNames.DuesRecordsMetrics,
          OrderBy: 'MetricDate DESC',
          MaxRows: 1,
          IgnoreMaxRows: false,
          skipActiveFilter: true,
          ResultType: 'simple'
        });
        this.summary = result.data[0];

    this.updateSummaryCards();
  }

  private updateSummaryCards(): void {
    this.summaryCards = [
      {
        id: 'total-dues-amount',
        value: `${this.summary.TotalDues}`,
        label: 'Total Dues',
        icon: '💰',
        variant: 'primary',
        format: 'currency'
      },
      {
        id: 'total-dues-collected',
        value: `${this.summary.Collected}`,
        label: 'Dues Collected',
        sublabel: 'Total amount collected',
        icon: '💰',
        variant: 'success',
        format: 'currency'
      },
      {
        id: 'total-dues-outstanding',
        value: `${this.summary.Outstanding}`,
        label: 'Total Outstanding',
        sublabel: 'Total outstanding amount',
        icon: '💰',
        variant: 'warning',
        format: 'currency'
      },
      {
        id: 'collection-rate',
        value: `${this.summary.CollectionRate}`,
        label: 'Collection Rate',
        icon: '💰',
        variant: 'info',
        format: 'percentage'
      },
      {
        id: 'overdue-records',
        value: `${this.summary.OverdueRecords}`,
        label: 'Overdue Records',
        icon: '💰',
        variant: 'danger',
        format: 'number'
      }
    ];
  }
  */
  
  get userRole(): string | null {
    // Get role from UserAuthService which fetches from API
    return this.userAuthService.getUserRole();
  }
}